import { MarketplaceOrderLabelTextHelper } from '../labelTextHelper/MarketplaceOrderLabelTextHelper';
import { HeaderItem } from '../../model/HeaderItem';

const excludedImportFieldList = [
    'orderId',
    'commissionCurrencyCode',
    'transactionFeeCurrencyCode',
    'commissionAmount',
    'orderStatus',
    'refundStatus',
    'paymentStatus',
    'shippingFeeAmount',
    'orderBalanceAmount',
    'orderItemSkuList',
    'dateCreateAt',
    'dateModifyAt'
];

export const MarketplaceOrderHeaderHelper = {
    getHeaderItems(): HeaderItem[] {
        return [
            { text: MarketplaceOrderLabelTextHelper.getLabelText.orderId, value: 'orderId' },
            {
                text: MarketplaceOrderLabelTextHelper.getLabelText.dateOrderOn,
                value: 'dateOrderOn',
                format: 'date'
            },
            { text: MarketplaceOrderLabelTextHelper.getLabelText.orderNumber, value: 'orderNumber' },
            { text: MarketplaceOrderLabelTextHelper.getLabelText.marketplaceCode, value: 'marketplaceCode' },
            { text: MarketplaceOrderLabelTextHelper.getLabelText.orderAmount, value: 'orderAmount' },
            { text: MarketplaceOrderLabelTextHelper.getLabelText.orderCurrencyCode, value: 'orderCurrencyCode' },
            { text: MarketplaceOrderLabelTextHelper.getLabelText.commissionPercentage, value: 'commissionPercentage' },
            { text: MarketplaceOrderLabelTextHelper.getLabelText.commissionAmount, value: 'commissionAmount' },
            {
                text: MarketplaceOrderLabelTextHelper.getLabelText.commissionCurrencyCode,
                value: 'commissionCurrencyCode'
            },
            { text: MarketplaceOrderLabelTextHelper.getLabelText.transactionFee, value: 'transactionFee' },
            {
                text: MarketplaceOrderLabelTextHelper.getLabelText.transactionFeeCurrencyCode,
                value: 'transactionFeeCurrencyCode'
            },
            { text: MarketplaceOrderLabelTextHelper.getLabelText.remarks, value: 'remarks' },
            { text: MarketplaceOrderLabelTextHelper.getLabelText.orderStatus, value: 'orderStatus' },
            { text: MarketplaceOrderLabelTextHelper.getLabelText.refundStatus, value: 'refundStatus' },
            { text: MarketplaceOrderLabelTextHelper.getLabelText.paymentStatus, value: 'paymentStatus' },
            { text: MarketplaceOrderLabelTextHelper.getLabelText.shippingFeeAmount, value: 'shippingFeeAmount' },
            { text: MarketplaceOrderLabelTextHelper.getLabelText.orderBalanceAmount, value: 'orderBalanceAmount' },
            { text: MarketplaceOrderLabelTextHelper.getLabelText.orderItemSkuList, value: 'orderItemSkuList' },
            {
                text: MarketplaceOrderLabelTextHelper.getLabelText.dateCreateAt,
                value: 'dateCreateAt',
                format: 'datetime'
            },
            {
                text: MarketplaceOrderLabelTextHelper.getLabelText.dateModifyAt,
                value: 'dateModifyAt',
                format: 'datetime'
            }
        ];
    },

    getDateTimePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'datetime')
            .map((item) => item.value);
    },

    getDatePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'date')
            .map((item) => item.value);
    },

    getActionHeaderItem(): HeaderItem {
        return { text: MarketplaceOrderLabelTextHelper.getLabelText.action, value: 'action' };
    },

    getCsvHeader() {
        return [...this.getHeaderItems().map((item) => ({ key: item.value, text: item.text }))];
    },

    getHeaders() {
        return [...this.getHeaderItems(), this.getActionHeaderItem()];
    },

    getImportFields() {
        return this.getFilteredHeaderItems().reduce((acc, item) => {
            acc[item.value] = {
                required: false,
                label: item.text
            };
            return acc;
        }, {} as Record<string, { required: boolean; label: string }>);
    },

    getImportHeaders() {
        return this.getFilteredHeaderItems();
    },

    getFilteredHeaderItems() {
        return this.getHeaderItems().filter((header) => !excludedImportFieldList.includes(header.value));
    }
};
